// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"080f0763f73bcff80f05","883":"17a28022162eb1d99d83"}[chunkId] + ".js";
};